(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-logos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-press-toggle]');
    if (!button) return;
    var root = button.closest('.wt-press');
    if (!root) return;
    var paused = root.classList.toggle('is-paused');
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('aria-label', paused ? 'Play the moving press logos' : 'Pause the moving press logos');
    var text = button.querySelector('[data-press-toggle-text]');
    if (text) text.textContent = paused ? button.dataset.labelPlay : button.dataset.labelPause;
  });

  } catch(e) { console.error(e); }
})();
})();
